import { QuestionTypeNumberScale } from "../../types/gameSession";
import { useAppDispatch, useAppSelector } from "../../app/store";
import { updateNumberScale } from "../../app/slices/gameSession";

type Props = {
    question: QuestionTypeNumberScale;
    npsScale: boolean;
    LANG: Record<string, string>;
}

const QuestionNumberScale = ({ question, npsScale, LANG }: Props) => {
    const dispatch = useAppDispatch();
    const pending = useAppSelector((state) => state.gameSession.pending);
    const disabled = pending || !question.can_edit;

    const handleOptionSelect = (rating: number) => {
        if (disabled) return;
        dispatch(updateNumberScale({ rating }));
    };

    return (
        <div className='number-scale-container'>
            <div className={`scale-options ${question.options.length > 5 ? 'scale-over' : ''}`}>
                {question.options.map(({selected, rating, option}) => (
                    <button type="button" disabled={disabled}
                        key={`scale-option-${rating}`}
                        className={`scale-option ${selected ? 'selected' : ''}`}
                        onClick={() => handleOptionSelect(rating)}
                    >
                        <div className="option-content">
                            <span className="option-rating circle">{rating}</span>
                            {question.options.length <= 5 && <span className="option-text">{option}</span>}
                        </div>
                    </button>
                ))}
            </div>
            {question.options.length > 5 && (
                <div className="option-texts">
                    {question.options.map(({ key, rating,  option }) => (
                        option && <div key={key} className="option-text">
                            <span className='option-text-rating'>{rating} = </span>
                            {option}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default QuestionNumberScale;
